import generateTypes from '../utils/generateTypes';

export const GET_USERS = generateTypes('GET_USERS');
export const RESET_USERS = generateTypes('RESET_USERS');
